let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = Promise.all([load("ce3Ni"), load("jtXXq"), load("6cVEd")]).then(() => parcelRequire('bSBwg'));